module.exports = __webpack_public_path__ + "img/1.8d328e12.jpg";